import { CareTaskStoreState } from './care-task-store.types';

export const STORE_NAME: string = 'CARE_TASK';
export const FIRST_COMP_INDEX = 0;
export const FIRST_COMP_PREVIOUS_INDEX = -1;

export const initialState: CareTaskStoreState = {
  careTasks: [],
  taskAnswering: {
    siteUuid: null,
    taskId: null,
    isAnsweringMain: true,
    navigator: {
      current: FIRST_COMP_INDEX,
      previous: FIRST_COMP_PREVIOUS_INDEX,
    },
  },
};
